import { Box, Button, Grid, Paper, Typography } from "@mui/material";
import axios from "axios";
import { useEffect, useState } from "react";

const ModeSelector = ({ onSelect }) => {
  const [resvMenu, setResvMenu] = useState([]);

  useEffect(() => {    
    // Get data Reservasi Menu
    axios({
        method: "get",
        url: `https://script.google.com/macros/s/AKfycbwMR-2Dk9gpd5_KlmhL1Lgk_opPU6OOzb-KJQjizlRtYpKtX_Bp7QWa4i172CDKoRbE/exec?api=reservasi_menu`,     
      })
      .then((response) => {
        const rawData = response.data;
        setResvMenu(rawData.data);
      })
      .catch((err) => {});
  }, []);    

  return (    
    <Grid container justifyContent="center">
      <Grid item xs={11} sm={7} md={5} lg={4}>    
        <Paper
          elevation={4}
          sx={{
            p: 4,          
            width: "100%",
            borderRadius: 4,
            textAlign: "center",
          }}
        >
          <Typography variant="h5" fontWeight={700}>
            Hello Sobat Kabita 👋
          </Typography>

          <Typography fontSize=".85em" color="text.secondary" mt={1}>
            Silakan pilih jenis reservasi untuk melanjutkan
          </Typography>

          {/* <Box display="flex" flexDirection="column" gap={2} mt={4}>
            <Button
              size="large"
              variant="contained"
              color="success"
              sx={{
                py: 1.5,
                borderRadius: 3,
                fontWeight: 600,
                fontSize: "1rem",
                transition: ".2s",
                "&:hover": { transform: "scale(1.03)" },
              }}
              onClick={() => onSelect("dinein")}
            >
              🍽 Dine In / Bukber
            </Button>

            <Button
              size="large"
              variant="contained"
              color="warning"
              sx={{
                py: 1.5,
                borderRadius: 3,
                fontWeight: 600,
                fontSize: "1rem",
                transition: ".2s",
                "&:hover": { transform: "scale(1.03)" },
              }}
              onClick={() => onSelect("catering")}
            >
              🍱 Catering
            </Button>
          </Box> */}

          {/* Pilihan reservasi type */}
          <Box display="flex" flexDirection="column" gap={2} mt={4}>
            {resvMenu
              .filter((item) => item.active === true)
              .map((item) => (
                <Button
                  key={item.reservasi_type}
                  size="large"
                  variant="contained"
                  color={
                    item.reservasi_type === "dinein"
                      ? "success"
                      : item.reservasi_type === "catering"
                      ? "warning"
                      : "primary"
                  }
                  sx={{
                    py: 1.5,
                    borderRadius: 3,
                    fontWeight: 600,
                    fontSize: "1rem",
                    transition: ".2s",
                    "&:hover": { transform: "scale(1.03)" },
                  }}
                  onClick={() => onSelect(item.reservasi_type)}
                >
                  {item.reservasi_name}
                </Button>
              ))}
          </Box>

          <Typography fontSize=".75em" color="text.secondary" mt={3}>
            Butuh info lebih lanjut?{" "}
            <Box
              component="span"
              sx={{ cursor: "pointer", fontWeight: 600 }}              
            >
              <a 
                href="https://wa.me/+62882002670116?text=Hello%20Kabita%20Group.%20Saya%20butuh%20informasi%20terkait%20reservasi." 
                style={{ 
                  textDecoration: "none",
                  color: "blue"
                }}
              >
                Hubungi admin
              </a>              
            </Box>
          </Typography>
        </Paper>    
      </Grid>
    </Grid>
  );
};

export default ModeSelector;
